import React from 'react';
import { Category } from './LinkSharing';

interface LinkCategoriesProps {
  categories: Category[];
  selectedCategory: string;
  onCategorySelect: (category: string) => void;
}

export const LinkCategories: React.FC<LinkCategoriesProps> = ({
  categories,
  selectedCategory,
  onCategorySelect
}) => {
  const getCategoryEmoji = (category: string) => {
    const emojiMap: { [key: string]: string } = {
      course: '🎓',
      tutorial: '📚',
      article: '📝',
      tool: '🛠️',
      documentation: '📖',
      video: '🎥',
      podcast: '🎧',
      book: '📚',
      research: '🔬',
      general: '🔗'
    };
    return emojiMap[category] || '🔗';
  };

  const totalLinks = categories.reduce((sum, cat) => sum + cat.count, 0);

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Categories</h3>
      
      <div className="space-y-2">
        <button
          onClick={() => onCategorySelect('')}
          className={`w-full flex items-center justify-between px-3 py-2 text-left rounded-lg transition-colors duration-200 ${
            selectedCategory === '' 
              ? 'bg-blue-100 text-blue-800 border-l-4 border-blue-600' 
              : 'hover:bg-gray-50 text-gray-700'
          }`}
        >
          <div className="flex items-center gap-2">
            <span>🌟</span>
            <span className="font-medium">All Categories</span>
          </div>
          <span className="text-sm bg-gray-100 text-gray-600 px-2 py-1 rounded-full">
            {totalLinks}
          </span>
        </button>

        {categories.map((category) => (
          <button
            key={category.category}
            onClick={() => onCategorySelect(category.category)}
            className={`w-full flex items-center justify-between px-3 py-2 text-left rounded-lg transition-colors duration-200 ${
              selectedCategory === category.category
                ? 'bg-blue-100 text-blue-800 border-l-4 border-blue-600'
                : 'hover:bg-gray-50 text-gray-700'
            }`}
          >
            <div className="flex items-center gap-2">
              <span>{getCategoryEmoji(category.category)}</span>
              <span className="font-medium capitalize">{category.category}</span>
            </div>
            <span className="text-sm bg-gray-100 text-gray-600 px-2 py-1 rounded-full">
              {category.count}
            </span>
          </button>
        ))}
      </div>

      {categories.length === 0 && (
        <div className="text-center py-8 text-gray-500">
          <div className="text-4xl mb-2">📂</div>
          <p className="text-sm">No categories yet</p>
        </div>
      )}

      <div className="mt-6 pt-4 border-t border-gray-200">
        <div className="text-xs text-gray-500 text-center">
          <p className="mb-2">💡 Pro tip:</p>
          <p>Click on any category to filter links by type</p>
        </div>
      </div>
    </div>
  );
};